import type { Finalite } from '@rosetta/shared';

interface BandeauFinaliteProps {
  finalite: Finalite;
}

/**
 * The purpose of the text, above the two texts (#9): "Finalité :" in grey, the value in
 * semi-bold, then the explanation beside it. Both are what the analysis step of Tahiti said,
 * word for word: Rosetta writes none of it.
 */
export function BandeauFinalite({ finalite }: BandeauFinaliteProps) {
  return (
    <section
      aria-label="finalité du texte"
      className="flex flex-wrap items-baseline gap-x-4 gap-y-1 rounded-md bg-gray-50 px-6 py-4 text-body leading-[1.55]"
    >
      <p className="shrink-0 text-gray-700">
        Finalité : <span className="font-semibold text-black">{finalite.libelle}</span>
      </p>
      {finalite.explication === undefined ? null : (
        <p className="min-w-0 flex-1 basis-80 text-gray-800">{finalite.explication}</p>
      )}
    </section>
  );
}
